import axios from 'axios';
import config from '../config';
import reduxStore from '../redux/store';
import {updateLoading,showErrorMessage,logout} from '../redux/action';
import {getToken} from './utils';

const instance = axios.create({
    baseURL: config.apiUrl
});


const requestHandler = (request) => {
    if(config.whiteListApis.includes(request.url)){
        return request;
    }

    request.headers['x-access-token'] = getToken();
    reduxStore.dispatch(updateLoading(true));
    return request;
};
const responseHandler = (response) => {
    const {data} = response;
    reduxStore.dispatch(updateLoading(false));

    if(data.statusCode === 401){
        return reduxStore.dispatch(logout());
    }
    if(data.statusCode !== 200){
        return errorHandler({message:data.error});
    }
   
    return data;
};

const errorHandler = (error) => {
    reduxStore.dispatch(updateLoading(false));
    reduxStore.dispatch(showErrorMessage(error.message));
    setTimeout(() =>{
        reduxStore.dispatch(showErrorMessage(""));
    },500);
    return Promise.reject(error);
};


instance.interceptors.request.use(requestHandler, errorHandler);

instance.interceptors.response.use(responseHandler, errorHandler);


export default instance;